import { combineReducers } from 'redux';
import contract from './lease_contract/reducer';
import auth from './auth/reducer';
import user from './user/reducer';
import error from './error/reducer';
import webpay from './webpay/reducer';
import mail from './mail/reducer';
import coupon from './coupon/reducer';
import dashboard from './dashboard/reducer';
import assets from './assets/reducer';
import forms from './forms/reducer';
import download from './downolad_docs/reducer';

export default combineReducers({
  auth,
  contract,
  user,
  error,
  webpay,
  mail,
  coupon,
  dashboard,
  assets,
  forms,
  download,
});